import React from "react";

const NavDots = (props) => {
  return (
    <div className="app__navigation">
      {["home", "about", "work", "skills", "testimonials", "contact"].map(
        (item, ind) => (
          <a
            href={`#${item}`}
            key={item + ind}
            className="app__navigation-dot"
            style={props.active === item ? { backgroundColor: "#313BAC" } : {}}
          />
        )
      )}
    </div>
  );
};

export default NavDots;
